<template>
    <div class="script-container">
        <div v-if="isAgentSharedView" class="rounded-md border border-slate-200 bg-slate-50 px-4 py-6 text-sm text-slate-800 flex flex-wrap items-center gap-2">
            <span>Refinance tools are available to the listing agent for this property.</span>
            <ToolTip
                v-if="viewOnlyTooltip"
                :title="viewOnlyTooltip.title"
                :description="viewOnlyTooltip.description"
            />
        </div>
        <div v-else class="bg-white shadow-md rounded-lg overflow-hidden">
            <div class="p-6">
                <!-- Container where the script might inject an iframe or content -->
                <div ref="scriptContainer" class="w-full min-h-[500px]"></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { usePage } from '@inertiajs/vue3'
import ToolTip from '@/Shared/ToolTip.vue'

const props = defineProps({
    property: {
        type: Object,
        required: true
    },
    tab: {
        type: String,
        default: 'refinance'
    },
    tabData: {
        type: Object,
        default: () => ({})
    },
    propertyAccess: {
        type: String,
        default: 'owner',
    },
    viewOnlyTooltip: {
        type: Object,
        default: null,
    },
})

const page = usePage()
const scriptContainer = ref(null)

const isAgentSharedView = computed(() => {
    return page.props.user?.role === 'agent' && props.propertyAccess === 'shared_view'
})

onMounted(() => {
    if (isAgentSharedView.value) {
        return
    }
    
    // Create and append the script tag dynamically
    const script = document.createElement('script')
    script.src = 'https://www.mortgageresearchcenter.com/scripts/rentRisk.js'
    script.async = true
    script.setAttribute('data-mrc', 'RentRisk')
    script.setAttribute('data-mrc-color', '#c3a123')
    script.setAttribute('data-mrc-color-hover', '#323c61')
    
    if (page.props.user?.role === 'applicant') {
        script.setAttribute('data-mrc-desc', 'vafinance')
    }
    if (page.props.user?.role === 'agent') {
        script.setAttribute('data-mrc-desc', 'vaready')
    }
    
    script.onerror = () => console.error('Failed to load script')
    
    if (scriptContainer.value) {
        scriptContainer.value.appendChild(script)
    }
})
</script>
